<template>
    <div v-if="this.currType !== 'ordina_tavolo'">
        <div class="title">{{$t('ordine_scelta_orario_titolo')}}</div>
        <options-carousel
            v-if="this.entries.length"
            ref="carousel"
            :initial-idx="this.initial_time_idx"
            :entries="this.entries"
            @onSnapToItem="this.onSnapToItem"
        />
        <div class="pb-3 pt-3" v-else>
            <h5>{{this.$t('nessuna_fascia_disponibile')}}</h5>
        </div>
    </div>
</template>

<script>
import OptionsCarousel from "./OptionsCarousel";

export default {
    name: "Lv3",
    components: {OptionsCarousel},
    props: ['configurazione', 'initTime', 'currType'],
    data() {
        return {
            curr_idx: null
        };
    },
    mounted() {
        try {
            this.carousel.$refs.swiper.$swiper.slideTo(this.initial_time_idx);
            this.carousel.clickSlide(this.initial_time_idx);
        } catch (e) {
            //Amen
        }

        if (this.currType === 'ordina_tavolo') {
            this.onSnapToItem(this.initial_time_idx);
        }
    },
    computed: {
        carousel: function () {
            return this.$refs.carousel;
        },
        entries: function () {
            return this.configurazione.hours.map((ora) => ({
                primaryText: ['delivery', 'dil'].includes(this.currType) ? ora.from + ' - ' + ora.to : ora.from,
                secondaryText: null,
                value: ora,
            }));
        },
        initial_time_idx: function () {
            if (this.initTime) {
                const idx = this.entries.findIndex((entry) => entry.value.from === this.initTime);
                return idx !== -1 ? idx : 0;
            } else {
                return 0;
            }
        }
    },
    watch: {
        entries: function () {
            this.carousel.$refs.swiper.$swiper.slideTo(0);
            this.carousel.clickSlide(0);
        }
    },
    methods: {
        onSnapToItem: function (index) {
            this.curr_idx = index;

            let value = null;
            if (this.entries[index]) {
                value = this.entries[index].value;
            }
            this.$emit('onTimeChange', value);
        }
    }
}
</script>
